

























































































































































































































import { Component, Model, Prop, Watch } from 'vue-property-decorator';
import CommonVue from '@/models/commonVue';
import { BusEvent } from '@/models/bus';

import { ExerciseGameType, LessonGameType } from '@/api/common';
import Lesson from '@/api/lesson';
import Exercise from '@/api/exercise';

import ArrowIcon from '@/components/icons/ArrowIcon.vue';
import ListExercise from '@/components/listView/ListExercise.vue';
import EditExerciseConversation from '@/editComponents/EditExerciseConversation.vue';
import EditExerciseConversationFree from '@/editComponents/EditExerciseConversationFree.vue';
import EditExercisePronunciation from '@/editComponents/EditExercisePronunciation.vue';
import EditExerciseWordStress from '@/editComponents/EditExerciseWordStress.vue';
import EditExerciseSentenceStress from '@/editComponents/EditExerciseSentenceStress.vue';
import EditExerciseAudioText from '@/editComponents/EditExerciseAudioText.vue';
import EditExerciseTextAudio from '@/editComponents/EditExerciseTextAudio.vue';
import EditExerciseVideoConversation from '@/editComponents/EditExerciseVideoConversation.vue';
import EditExerciseSingleField from '@/editComponents/EditExerciseSingleField.vue';
import EditExerciseMissingCharacter from '@/editComponents/EditExerciseMissingCharacter.vue';
import EditExerciseUnscrambleWord from '@/editComponents/EditExerciseUnscrambleWord.vue';

@Component({
  components: {
    'list-exercise': ListExercise,
    'edit-exercise-conversation': EditExerciseConversation,
    'edit-exercise-conversation-free': EditExerciseConversationFree,
    'edit-exercise-pronunciation': EditExercisePronunciation,
    'edit-exercise-word-stress': EditExerciseWordStress,
    'edit-exercise-sentence-stress': EditExerciseSentenceStress,
    'edit-exercise-audio-text': EditExerciseAudioText,
    'edit-exercise-text-audio': EditExerciseTextAudio,
    'edit-exercise-video-conversation': EditExerciseVideoConversation,
    'edit-exercise-single-field': EditExerciseSingleField,
    'edit-exercise-missing-character': EditExerciseMissingCharacter,
    'edit-exercise-unscramble-word': EditExerciseUnscrambleWord,
    'arrow-icon': ArrowIcon
  },
  beforeRouteLeave(to, from, next) {
    if (
      (this.exercise || !(this.exercise === undefined)) &&
      this.exercise.isDirty
    ) {
      let answer = window.confirm(
        'Do you really want to leave? you have unsaved changes!'
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
})
export default class ExerciseView extends CommonVue {
  @Prop({ type: Number }) public moduleId!: number;
  @Prop({ type: Number }) public lessonId!: number;
  @Prop({ type: Number }) public id?: number;
  @Prop({ type: Boolean, default: false }) public isEdit!: boolean;
  @Prop() public gameType?: string;
  @Prop() public parent?: string;
  @Prop({ type: Boolean, default: false }) public isProgram: boolean;
  @Prop({ type: Boolean, default: false }) public isModule: boolean;

  public lesson: Lesson = null;
  public exercise: Exercise = null;
  public gt: string = '';
  public gameTypeOptions: string[] = this.getGameTypeOptions();
  public optionsShowing: boolean = false;

  public async beforeMount() {
    await this.load();
  }

  @Watch('isEdit')
  public async load() {
    await this.loadLesson();
    if (!this.isEdit) {
      await this.loadLesson();
      this.exercise = undefined;
    } else {
      await this.loadExercise();
    }
  }

  public async loadExercise(): Promise<void> {
    this.busy = true;
    try {
      if (this.isNew) {
        this.exercise = new Exercise(this.gameType);
        this.exercise.parent_lesson = this.lessonId;
      } else {
        this.exercise = await Exercise.get(this.id);
      }
      this.gt = this.exercise.game_type;
      this.exercise.isDirty = true;
    } catch (e) {
      this.error = true;
      this.$bus.$emit(BusEvent.ERROR, 'Could not get exercise information', e);
    } finally {
      this.busy = false;
    }
  }

  public async loadLesson(): Promise<void> {
    this.busy = true;
    try {
      this.lesson = await Lesson.get(this.lessonId);
      if (this.lesson.game_type === LessonGameType.MIXED_GAME) {
        this.gameTypeOptions = ExerciseGameType.OPTIONS.filter(
          (el) => el !== ExerciseGameType.PICK_YOUR_ANSWER
        );
      }
    } catch (e) {
      this.error = true;
      this.$bus.$emit(BusEvent.ERROR, 'Could not get lesson information', e);
    } finally {
      this.busy = false;
    }
  }

  public toggleOptions() {
    this.optionsShowing = !this.optionsShowing;
  }

  // noinspection JSMethodCanBeStatic
  public typeToPresentation(game_type: string): string {
    return ExerciseGameType.typeToPresentation(game_type);
  }

  // noinspection JSMethodCanBeStatic
  public typeToSlug(game_type: string): string {
    return ExerciseGameType.typeToSlug(game_type);
  }

  private getGameTypeOptions() {
    if (!this.isProgram) {
      if (this.isModule) {
        return ExerciseGameType.OPTIONS.filter(
          (item) =>
            item !== ExerciseGameType.INSIGHT_ONLY
        );  
      }
      return ExerciseGameType.OPTIONS.filter(
        (item) =>
          item !== ExerciseGameType.INSIGHT_ONLY &&
          item !== ExerciseGameType.VIDEO_ONLY
      );
    } else {
      return ExerciseGameType.OPTIONS.filter(
        (item) =>
          item !== ExerciseGameType.CONVERSATION_FREE
      );
    }
  }
}
